// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:08:15
import { Guid, GuidTools } from '@models/guid';
import { BaseObject } from '@models/BaseObject';

export abstract class MapSector_abstract extends BaseObject {
  static $t: string = 'SagaBase.Defines.MapSector';
  $t: string = 'SagaBase.Defines.MapSector';

  public static GetMembers(): string[] {
    return ['MapSectorId', 'MapSectorName', 'MapLayerId', 'MapLayerName'];
  }

  public GetMembers(): string[] {
    return MapSector_abstract.GetMembers();
  }

  public _init(): void {
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/
    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public MapSectorId: number = 0;
  public MapSectorName: string;
  public MapLayerId: number = 0;
  public MapLayerName: string;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  /*</AUTO_IMPLEMENTATION>*/
}
